import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const PlanVariations = styled.div<{ isStacked?: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  ${QUERIES.largeTabletAndUp} {
    ${({ isStacked }) => !isStacked && `grid-template-columns: 1fr 1fr;`}
  }
`;
